import { Box, IconButton, Image, Text, Flex } from "@chakra-ui/react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { MdMargin } from "react-icons/md";

const Mycart = ({ botDetails, isColorDark, mycart, handleQty }) => {

  const currencySymbol = botDetails.storeName === "Shopify"?mycart?.currency=== "INR" ? "Rs" : "":mycart?.currency?.code==="INR" ? "Rs" : "";
// console.log(mycart,"=======+> mycart")
  const renderCartItem = (el, key, isShopify = true) => (
    <Flex
      key={key}
      boxShadow="lg"
      borderRadius="12px"
      overflow="hidden"
      bg="white"
      p={4}
      alignItems="center"
      gap={4}
      transition="0.3s"
      _hover={{ transform: "scale(1.02)" }}
      style={{marginBottom:"10px"}}
    >
      <Image
        src={isShopify ? el.image : el.imageUrl}
        alt={isShopify ? el.product_title : el.name}
        boxSize="80px"
        objectFit="cover"
        borderRadius="8px"
      />
      <Flex flexDirection="column" flex={1}>
        <Text fontSize="lg" fontWeight="bold" isTruncated style={{whiteSpace:"nowrap",overflow: "hidden", textOverflow: "ellipsis", width: "200px"}}>
          {isShopify ? el.product_title : el.name}
        </Text>
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize="md" color="gray.600">
            {currencySymbol}
            {Number(isShopify
              ? `${el?.price.toString().slice(0, -2)}.${el?.price.toString().slice(-2)}`
              : el?.price || el?.salePrice) * el?.quantity}
          </Text>
       
        </Flex>
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize="md" color="gray.600">
           
          </Text>
          <Flex
            border="1px solid"
            borderColor={isColorDark(botDetails?.accentColor) ? botDetails?.accentColor : "#dadada"}
            borderRadius="8px"
            alignItems="center"
            justifyContent="space-around"
            w="90px"
          >
            <IconButton
              icon={<AiOutlineMinus />}
              size="sm"
              variant="ghost"
              onClick={() => handleQty(el.quantity - 1, isShopify ? el.variant_id : el.variantId, isShopify?el?.product_id  :el?.productId ,el?.id)}
            />
            <Text>{el.quantity}</Text>
            <IconButton
              icon={<AiOutlinePlus />}
              size="sm"
              variant="ghost"
              onClick={() => handleQty(el.quantity + 1, isShopify ? el.variant_id : el.variantId,isShopify?el?.product_id  :el?.productId ,el?.id)}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );

  return (
    <Box mb={6} w="90%" mx="auto">
      {botDetails?.storeName === "Shopify" && mycart?.items?.length ? (
        mycart.items.map((el, indx) => renderCartItem(el, indx, true))
      ) : botDetails?.storeName === "Bigcommerce" && mycart?.lineItems?.physicalItems?.length ? (
        mycart.lineItems.physicalItems.map((el, indx) => renderCartItem(el, indx, false))
      ) : (
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          mt={10}
          color="gray.600"
          p={6}
          borderWidth={1}
          borderRadius="lg"
          borderColor="gray.300"
          bg="gray.50"
          boxShadow="md"
          textAlign="center"
        >
          <Box as="span" fontSize="4xl" color="gray.400" mb={4}>
            🛒
          </Box>
          <Text fontSize="2xl" fontWeight="semibold" color="gray.700">
            Your cart is empty
          </Text>
          <Text fontSize="md" color="gray.500">
            Add items to your cart to see them here!
          </Text>
        </Flex>
      )}
    </Box>
  );
};

export default Mycart;
